export default function fSearch() {
    const oOverlay = document.querySelector('.js-search-overlay');
    const aOpeners = document.querySelectorAll('.js-search-open');
    const aClosers = document.querySelectorAll('.js-search-close');
    const oInputs = document.querySelectorAll('.search-box input[type="search"]');
    const oShowMore = document.querySelectorAll('.js-search-more');

    if (!oOverlay) return;

    const fSwitchOverlay = () => {
        let oOverlaySearchInput = oOverlay.querySelector('input[type="search"]')
        if (oOverlay.classList.contains('is-active')) {
            oOverlay.classList.remove('is-active');
            oOverlaySearchInput.blur();
        } else {
            oOverlay.classList.add('is-active');

            setTimeout(function () {
                oOverlaySearchInput.focus();
            }, 100);
        }
    }

    const fShowMoreSearchResults = (e) => {
        const oSearchResultContainer = e.currentTarget.closest('.search-detail__results');
        const aSearchResults = oSearchResultContainer.querySelectorAll('.search-detail__results__item');

        for (let r = 0; r < aSearchResults.length; r += 1) {
            if (aSearchResults[r].classList.contains('search-detail__results__item--hidden')) {
                aSearchResults[r].classList.remove('search-detail__results__item--hidden');
            }
        }

        e.currentTarget.parentNode.removeChild(e.currentTarget);
    }

    for (let a = 0; a < aOpeners.length; a += 1) {
        aOpeners[a].addEventListener('click', fSwitchOverlay);
    }

    for (let a = 0; a < aClosers.length; a += 1) {
        aClosers[a].addEventListener('click', fSwitchOverlay);
    }


    for (let o = 0; o < oShowMore.length; o += 1) {
        oShowMore[o].addEventListener('click', fShowMoreSearchResults);
    }

    for (let o = 0; o < oInputs.length; o += 1) {
        oInputs[o].addEventListener("keyup", (e) => {
            //const oSearchForm = e.target.parentElement;
            //const search = e.target.value;
            // if (search.length >= 3) {
            //     fetch(`/umbraco/surface/VelthuisSearch/SearchSuggestions?search=${search}`, {
            //         method: 'GET',
            //         credentials: "same-origin",
            //         headers: {
            //             'Content-Type': 'application/json'
            //         }
            //     })
            //     .then(response => response.json())
            //     .then((response) => {
            //         let hasSearchBox = oSearchForm.querySelector('.search-box__list') !== null;
            //         let searchboxList = oSearchForm.querySelector('.search-box__list') || document.createElement('ul');
            //         searchboxList.className = 'search-box__list';
            //         searchboxList.innerHTML = '';

            //         if (response.length === 0) {
            //             let option = document.createElement('li');
            //             option.className = 'search-box__list__item search-box__list__item--no-result';
            //             option.textContent = 'Er zijn geen suggesties';
            //             searchboxList.appendChild(option);
            //         }

            //         for (let i = 0; i < response.length; i += 1) {
            //             let option = document.createElement('li');
            //             option.className = 'search-box__list__item';

            //             let optionLink = document.createElement('a');

            //             optionLink.setAttribute('href', `/zoeken/?q=${response[i]}`);
            //             optionLink.textContent = response[i];

            //             option.appendChild(optionLink);
            //             searchboxList.appendChild(option);
            //         }

            //         if(!hasSearchBox) {
            //             oSearchForm.appendChild(searchboxList);
            //         }
            //    });
            //}
        });

        oInputs[o].addEventListener("blur", (e) => {
            const oSearchForm = e.target.parentElement;
            const searchboxList = oSearchForm.querySelector('.search-box__list');
            const relTarget = e.relatedTarget || document.activeElement.closest('.search-box');

            if (searchboxList && relTarget === null) {
                oSearchForm.removeChild(searchboxList);
            }
        });
    }
}
